import { createReducer, on } from "@ngrx/store";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import {
  groupTimeSLotLoadErrorAction,
  groupTimeSlotLoadInitStartAction,
  groupTimeSlotLoadSuccessAction,
  groupTimeSlotUnsetKeyStorage,
  timeSlotListPopulateWithOldDataAction,
  timeSLotLoadErrorAction,
  timeSlotLoadInitStartAction,
  timeSlotLoadSuccessAction,
  timeSlotUnsetKeyStorage,
} from "../actions/time-slot.action";

/**
 * Initial state of areas store
 */
const initialState: GenericStoreApiData = {
  loaded: false,
  errorGeneric: false,
  errorNotYetImplemented: false,
  isOldDataInUse: false,
  data: null,
};

//#region TIme slot
/**
 * Reducer for Time slot
 */
export const TimeSlotReducer = createReducer(
  initialState,
  on(timeSlotUnsetKeyStorage, (timeSlotObject: GenericStoreApiData, action) => {
    return initialState;
  }),
  /*
    on(
      timeSlotLoadInitStartAction,
      (timeSlotObject: GenericStoreApiData, action) => {
        return { ...timeSlotObject, loaded: false };
      }
    ),
  */
  on(
    timeSlotLoadSuccessAction,
    (timeSlotObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.timeSlotObject,
      };
    }
  ),
  on(
    timeSlotListPopulateWithOldDataAction,
    (timeSlotObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: true,
        data: action.oldTimeSlotObject,
      };
    }
  ),
  on(timeSLotLoadErrorAction, (timeSlotObject: GenericStoreApiData, action) => {
    return {
      loaded: true,
      errorGeneric: true,
      errorNotYetImplemented: false,
      isOldDataInUse: false,
      data: null,
    };
  })
);
//#endregion

//#region Group Time slot
/**
 * Reduce for group time slot
 */
export const GroupTimeSlotReducer = createReducer(
  initialState,
  on(
    groupTimeSlotUnsetKeyStorage,
    (groupTimeSlotObject: GenericStoreApiData, action) => {
      return initialState;
    }
  ),
  on(
    groupTimeSlotLoadInitStartAction,
    (groupTimeSlotObject: GenericStoreApiData, action) => {
      return { ...groupTimeSlotObject, loaded: false };
    }
  ),
  on(
    groupTimeSlotLoadSuccessAction,
    (groupTimeSlotObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.groupTimeSlotObject,
      };
    }
  ),
  on(
    groupTimeSLotLoadErrorAction,
    (groupTimeSlotObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null,
      };
    }
  )
);
//#endregion
